import { isNativeFilePickerOpen } from "@/lib/nativeFilePicker";

const PORTALED_PICKER_SELECTORS = [
  '[data-slot="popover-content"]',
  '[data-slot="select-content"]',
  '[data-slot="sheet-content"]',
] as const;

/** True when the event target is inside a portaled picker (popover, select, sheet). */
export function isPortaledPickerTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return PORTALED_PICKER_SELECTORS.some((selector) => target.closest(selector) != null);
}

/** True when a dialog should ignore outside focus/pointer dismiss (native pickers, portaled UI). */
export function shouldPreventDialogDismiss(_target?: EventTarget | null): boolean {
  return isPortaledPickerTarget(_target ?? null) || isNativeFilePickerOpen();
}
